'use strict';

var App = require('app');
var AppState = require('app_state');
var Misc = require('utils/misc');
var OOP = require('utils/oop');
var I18N = require('utils/i18n');
var Utils = require('components/common/utils');

var DeviceReportItemView = OOP.extend(Marionette.ItemView, {
    template: require('components/profile/templates/device_report_content_part'),

    serializeData: function () {
        var data = this.base.serializeData();
        data.filter = AppState.filterToStr(data.filter);
        _.each(data.fields, function (f) {
            f.type_icon = Misc.reportModeIconByID(f.mode);
        });

        data.isCSVreport = this.options.reportType == 1;

        // check sort properties
        var sortColumn = this.model.get('sort_col') || 'name';
        var sortDesc = this.model.get('sort_desc') || false;
        var sortLimit = this.model.get('limit') || 0;

        // show sorting properties only if they are not set to default
        data.show_sort_col = sortColumn != 'name' || sortDesc || sortLimit > 0;
        if (data.show_sort_col) {
            data.sort_col_name = I18N.TR('Name');
            _.each(AppState.uniqueFields(), function (f) {
                if (f.id == sortColumn) {
                    data.sort_col_name = f.name;
                }
            });
        }

        return data;
    },

    events: OOP.inheritedObj('events', {
        'click .js-edit': function () {
            this.options.controller.reportDevicesContentEdit(this.options.reportID, this.model);
        },
        'click .js-delete': function (e) {
            e.preventDefault();
            e.stopPropagation();

            var self = this;
            this.model.reportID = this.options.reportID;
            Utils.deleteModels({
                models: [this.model],
                success: function () {
                    App.trigger('profile:reports:device', self.options.reportID);
                },
            });
        },
        'click .js-up': function () {
            this.move('up');
        },
        'click .js-down': function () {
            this.move('down');
        },
    }),

    move: function (dir) {
        var self = this;
        this.model.reportID = this.options.reportID;
        this.options.controller.reportDevicesContentMove(this.model, dir);
    },
});

module.exports = OOP.extend(Marionette.CompositeView, {
    template: require('components/profile/templates/device_report_content'),

    regions: {
        breadcrumbs: '#breadcrumbs',
    },

    childViewContainer: '#master',
    childView: DeviceReportItemView,

    childViewOptions: function () {
        return {
            reportID: this.options.reportID,
            reportType: this.options.format,
            controller: this.options.controller,
        };
    },

    onAttach: function () {
        /*
		Misc.loadAdditionalFile(
			'jquery-ui.min.js',
			'js'
		);

		// TODO: .. implement drag and drop configuration ..
		//       see https://api.jqueryui.com/sortable/

		var self = this;
		setTimeout(function() {
			$('#master').sortable({
				placeholder: 'part-dnd-placeholder',
				forcePlaceholderSize: true,
				update: function (event, ui) {
					// debugger;
				},
			});
			$('.content-list').sortable({
				update: function (event, ui) {
					// debugger;
				},
			});

		}, 2000);
*/
    },

    serializeData: function () {
        return {
            id: this.options.reportID,
            name: this.options.reportName,
            handle: this.options.handle,
            noAdd: this.options.format == 1 && this.collection.length > 0,
        };
    },
});
